import { Panel } from "../../../components/panels/Panel";
import { useEffect, useState } from "react";
import { getInfluxdbData } from "../../../services/api/influxdb-tools";
import { Loader } from "../../../components/loading/Loader";


export const ConstructionDashboardTotalDuration = () => {
  const [filmingHours, setFilmingHours] = useState(0);

  useEffect(() => {
    const getData = async () => {
      const fullQuery = `
        from(bucket: "engine")
        |> range(start: -1y)
        |> filter(fn: (r) => r["_measurement"] == "battery_information")
        |> filter(fn: (r) => r["_field"] == "battery_percentage")
        |> filter(fn: (r) => r["client_id"] == "${process.env.REACT_APP_CUSTOMER_NAME}_1")
        |> filter(fn: (r) => r["battery"] == "0")
        |> aggregateWindow(every: 30m, fn: count, createEmpty: false)
        |> count()
        |> map(fn: (r) => ({ r with _value: float(v: r._value) * 0.5 }))
        |> yield(name: "uptime")
      `;

      let filmingHoursData = await getInfluxdbData(
        'engine',
        null,
        [],
        [],
        null,
        null,
        null,
        null,
        null,
        [],
        null,
        fullQuery,
        false,
        null,
      );
      console.log(filmingHoursData);
      setFilmingHours(filmingHoursData?.[0]._value ?? 0);
    };

    getData();
  }, []);

  return (
    <Panel noHeader={true} rounded={true} category="secondary" height="h-1/2">
      <div className="flex flex-col gap-8 items-center justify-center h-full text-3xl text-center p-8">
        {!(filmingHours > 0) ?
          <Loader category="transparent"/> :
          <>
            <div className="text-7xl text-perception-blue">
              {filmingHours} heures
            </div>
            Durée totale de captation
          </>
        }
      </div>
    </Panel>
  );
};